//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  components: {},
  props: [],
  data() {
    return {
      ids: this.$route.query.ids,
      //图片路径
      url: "",

      srcList: [
      ],

      // 表格部分
      size: "",
      list: [],
      yhkh: {},
      srcListImages: [],
      supplierImg: "",
      logoImg: [],
      // scImage: []
    };
  },
  mounted() { },
  created() {
    this.fn();
  },
  methods: {
    fn() {
      console.log(this.ids);
      this.$http.supplierApi.getSupplierDetail({ id: this.ids }).then((res) => {
        console.log(res);
        this.list = res.data;
        this.srcList = res.data.szProductsMediaList;
        console.log(this.srcList);
        this.srcListImages = [];
        this.yhkh = res.data.szEnterpriseAccount[0];

        res.data.szProductsMediaList.forEach((item) => {
          if (item.types == 30 && item.flag == 10) {
            this.logoImg.push(item.imgUrl);
          } else {
            this.logoImg = [];
          }

        });

        if (this.logoImg.length > 0) {
          this.supplierImg = this.logoImg.join(",");
        } else {
          this.supplierImg = "";
        }
      });
    },
  },
};
